<template>
<a-result status="500" title="500" subTitle="抱歉，服务器发生错误！">
    <template v-slot:extra>
      <a-button type="primary" @click="()=>{$router.push({path: '/'})}">返回首页</a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {},
  computed: {},
  components: {}
}
</script>

<style scoped>
</style>